import {
  AddToCurrentCartRequestedAction,
  AddToCurrentCartRequestedPayload,
  addToCurrentCartFailed,
  addToCurrentCartSucceeded
} from '../../carts/cartsSlice';
import {
  ApiCartAddToCartFailedAction,
  ApiCartAddToCartSucceededAction,
  apiCartAddToCartFailedType,
  apiCartAddToCartRequested,
  apiCartAddToCartSucceededType
} from '../../api/cart/addToCartApi';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '../session/waitForSucceededOrFailedAction';

function* addToCurrentCartSaga({ payload }: AddToCurrentCartRequestedAction): Generator {
  const {
    actionId: requestedActionId,
    customOrderType,
    productCode,
    quantity,
    storeCode,
    tracking
  }: AddToCurrentCartRequestedPayload = payload;
  const actionId: number = generateActionId();

  yield* put(
    apiCartAddToCartRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId,
      productCode,
      quantity,
      storeCode,
      tracking
    })
  );

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiCartAddToCartSucceededType,
    typeof apiCartAddToCartFailedType,
    ApiCartAddToCartSucceededAction,
    ApiCartAddToCartFailedAction
  >(actionId, apiCartAddToCartSucceededType, apiCartAddToCartFailedType);

  if (waitResult.type === 'succeeded') {
    const { addedQuantity, cart, isNewCart } = waitResult.action.payload.result;
    const sourceCustomOrderType = waitResult.action.payload.sourceCustomOrderType;
    const targetCustomOrderType = waitResult.action.payload.targetCustomOrderType;
    yield* put(
      addToCurrentCartSucceeded({
        addedQuantity,
        cart: convertCartToStateCart(cart),
        customOrderType: targetCustomOrderType,
        isNewCart,
        productCode,
        requestedActionId,
        requestedQuantity: quantity,
        sourceCustomOrderType
      })
    );
  } else {
    const { failedReason } = waitResult.action.payload;
    yield* put(
      addToCurrentCartFailed({
        requestedActionId,
        failedReason
      })
    );
  }
}

export default addToCurrentCartSaga;
